var React = require('react');

function Direct (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.3 20V12.35L5.5 6.55V9.625H4V4H9.625V5.5H6.575L12.8 11.725V20H11.3ZM14.125 10.9L13.075 9.85L17.425 5.5H14.375V4H20V9.625H18.5V6.55L14.125 10.9Z","fill":"#1DA1F2"}));
}

Direct.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Direct;

Direct.default = Direct;
